import Computer from "../../images/computer.jpg";
import Network from "../../images/network.jpg";
import CameraImg from "../../images/camera.jpg";
import Website from "../../images/website.jpg";
import Develop from "../../images/develop.jpg";
import Cloud from "../../images/cloud.jpg";
import Invoice from "../../images/invoice.jpg";
const data = [
  {
    id: "1",
    name: "الكمبيوتر",
    desc: "توفير وصيانة جميع اجهزه الكمبيوتر واللابتوب بجميع محتوياتها",
    image: Computer,
    icon: "computer",
  },
  {
    id: "2",
    name: "الشبكات",
    desc: "توفير جميع حلول الشبكات وتوفير خدمات الواي فاي والانترنت للكافيهات والفنادق والمكاتب ",
    image: Network,
    icon: "network",
  },
  {
    id: "3",
    name: "كاميرات المراقبه",
    desc: "تركيب وصيانه جميع انواع كاميرات المراقبه ( IP / CCTV Analog ) ",
    image: CameraImg,
    icon: "camera",
  },
  {
    id: "4",
    name: "مواقع الويب",
    desc: "يمكنك انشاء موقع الويب الخاص بك او بشركتك موقع احترافي باحدث التقنيات متجاوب مع جميع الشاشات واستخدام الرسوم المتحركه والالوان الجذابه التي تعطي الموقع الجمال والحيويه ",
    image: Website,
    icon: "website",
  },
  {
    id: "5",
    name: "تصميم البرامج",
    desc: "تصميم وتطوير جميع البرامج لتلائم جميع المستخدمين ( برامج المحاسبة - برامج الكاشير - برامج المطاعم والفنادق - برامج المصانع - برامج الفاتوره الالكترونيه) ",
    image: Develop,
    icon: "develop",
  },
  {
    id: "6",
    name: "الخدمات السحابيه",
    desc: `   
    
    القدرة علي استعاده الملفات التالفه والمحذوفه.
    تشفير البيانات وتأمين خدمتك السحابيه علي اعلي مستوي لضمان الحمايه الكامله ضد اي تهديد من محاولات الاختراق او الفيروسات.
    الضبط التلقائي لاوقات الذروه وارتفاع الاحمال علي السحابه وتحديد الخدمه المناسبه لنوع استخدامك.
    `,
    image: Cloud,
    icon: "cloud",
  },
  {
    id: "7",
    name: "الفاتوره الإلكترونيه",
    desc: `بامكانك الربط مع مصلحة الضرائب المصرية سواء الفاتورة الالكترونية او الايصال الالكتروني باخر اصدار معتمد من مصلحة الضرائب
   · امكانية الربط مع معظم الانظمة , ERP , POS
   · امكانية استيراد الفوايتر من الاكسيل
   · البرنامج مدمجه به كل انواع الضرائب من T1  الي  T20 والانواع الفرعية كل ضريبة علي حدي
   · البرنامج مدمجة به كل العملات المستخدمة والمعتمدة من موقع الضرائب
   · البرنامج مدمج به بكل الدول المسجلة واكوادها لدي الضرائب
   · البرنامج مدمجة به الوحدات للاصناف سواء بالمتر او علبة او صندوق....
   · تحميل حزمة من الفواتير المرسلة خلال فترة من موقع الضرائب والبحث فيها وحفظها في قاعدة البيانات الداخلية
   · احصائيات من موقع الضرائب مباشرة للفاتورة
   · احصائيات دقيقة للايصالات
   · ارسال الفوتير واشعارات الخصم ومراجعة الفواتير قبل ارسالها
   · ارسال الايصالات ومرتجع الايصال`,
    image: Invoice,
    icon: "invoice",
  },
];

export default data;
